<script setup lang="ts">
  defineOptions({ name: 'CPTabs', inheritAttrs: false })

  // External library imports
  import type { PropType } from 'vue'

  import { HLTabs } from '@platform-ui/highrise'

  // Type imports

  // Props definitions
  const props = defineProps({
    id: {
      type: String,
      required: false,
      default: undefined,
    },
    type: {
      type: String as PropType<'line' | 'segment'>,
      required: false,
      default: 'line',
    },
    placement: {
      type: String as PropType<'top' | 'bottom' | 'left' | 'right'>,
      required: false,
      default: 'top',
    },
    value: {
      type: [String, Number],
      required: false,
      default: undefined,
    },
    defaultValue: {
      type: [String, Number] as PropType<string | number>,
      required: false,
      default: undefined,
    },
    justifyContent: {
      type: String as PropType<'start' | 'end' | 'space-around' | 'space-between' | 'space-evenly' | 'center'>,
      required: false,
      default: 'start',
    },
    theme: {
      type: String as PropType<'neutral' | 'primary'>,
      required: false,
      default: 'primary',
    },
    size: {
      type: String as PropType<'sm' | 'md' | 'lg'>,
      required: false,
      default: 'md',
    },
    maxVisibleTabs: {
      type: Number,
      required: false,
      default: 5,
    },
  })

  // Emits definitions
  const emit = defineEmits<{
    'update:value': [value: string | number]
  }>()

  // User-defined functions
  const handleUpdateValue = (value: string | number) => {
    emit('update:value', value)
  }
</script>

<template>
  <HLTabs
    v-bind="$attrs"
    :id="props.id"
    :type="props.type"
    :placement="props.placement"
    :value="props.value"
    :default-value="props.defaultValue"
    :justify-content="props.justifyContent"
    :theme="props.theme"
    :size="props.size"
    :max-visible-tabs="props.maxVisibleTabs"
    @update:value="handleUpdateValue"
  >
    <slot />
  </HLTabs>
</template>
